import { ValidatorFn } from '@angular/forms'
import { ActivityItemsAPIModel, QueriesItemsAPIModel, StatusCountAPIModel, UserDashboardAPIModel } from './api.model'

export interface Login {
  token: string
}

export interface ActivityDashboardModel {
  activityItemsList: ActivityItemsAPIModel
  statusCountMap: StatusCountAPIModel[]
}

export interface DashboardModel extends UserDashboardAPIModel {}

export interface Column {
  name: string
  key: string
  key2?: string
  type: ColumnType
  build: Function
  cssClasses?: string[]
  filter?: {
    key: string
    type: FieldType
    getOptionsList?: Function
    validations?: [
      {
        message: string
        validator: ValidatorFn
        validationType: string
      }
    ]
  }
  sortByKey?: string
  anchor?: {
    link: Function
  }
}

export enum ColumnType {
  FLOAT,
  NUMBER,
  DATE,
  STRING,
  HTML
}

export interface QueriesDashboardModel {
  queriesItemsList: QueriesItemsAPIModel
  statusCountMap: StatusCountAPIModel[]
}

export enum FieldType {
  TEXT,
  NUMBER,
  DATE,
  SELECT,
  CHECKBOX,
  TEXT_AUTOCOMPLETE,
  SELECT_TASK_STATUS
}

export enum AuthType {
  OTP = 'OTP',
  PASSWORD = 'PASSWORD',
  SSO = 'SSO'
}

export enum SSOProvider {
  MICROSOFT
}
